import moment from "moment";
import React from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const getYMDDate = (dateStr) => {
  const date = dateStr?.split("/");
  return new Date([date[2], date[0], date[1]]);
};

const TaskTable = ({ tasks = [], onClickTableItem, type }) => {
  const _getLinkClassName = () => {
    return type === "ActionPlan"
      ? "text-action-plan action-plan"
      : "implementation";
  };
  const [translation] = useTranslation("translations");
  return (
    <Table className="bg-white my-tasks-liting-table ">
      <thead className={`${ window.location.pathname === "/" ? 'd-none' : ''}`}>
        <tr style={{ borderBottomWidth: "0px" }}>
          <th className="p-2">{translation("tasks")}</th>
          <th className="p-2">
            {type === "ActionPlan"
              ? translation("start-date")
              : translation("due-date")}
          </th>
          {window.location.pathname !== "/" &&
            <th className="p-2">Board</th>
          }
        </tr>
      </thead>
      <tbody className={`${ window.location.pathname === "/" ? 'border-top-0' : ''}`}>
        {type === "ActionPlan" &&
          tasks != null &&
          tasks
            .sort(function (a, b) {
              return (
                new Date(a.task?.action_plan_timeline_start) -
                new Date(b.task?.action_plan_timeline_start)
              );
            })
            .map((task, index) => {
              return (
                <tr key={`${task}${index}`}>
                  { window.location.pathname === "/" &&
                    <td width="70%" className="ps-0">
                      <Link to={`/my-tasks/${task?.task?.id}`}>{task?.task?.title}</Link>
                    </td>
                  }
                  { window.location.pathname !== "/" &&
                    <td width="40%" onClick={() => onClickTableItem(task)}>
                      {task?.task?.title}
                    </td>
                  }
                  
                  <td width="30%">
                    {task?.task?.action_plan_timeline_start
                      ? moment(
                          getYMDDate(task?.task?.action_plan_timeline_start) ??
                            ""
                        ).format("ll")
                      : "-"}
                  </td>
                  {window.location.pathname !== "/" &&
                    <td width="30%">
                      <Link
                        className={`col-12 col-md-6 col-lg-auto mt-4 ${_getLinkClassName()}`}
                        key={index}
                        to={`/board/${task?.board_id}`}
                      >
                        {task?.board_name}
                      </Link>
                    </td>
                  }
                </tr>
              );
            })}

        {type === "Implementation" &&
          tasks != null &&
          tasks
            .sort(function (a, b) {
              return (
                new Date(a.task?.implementation_timeline_end) -
                new Date(b.task?.implementation_timeline_end)
              );
            })
            .map((task, index) => {
              return (
                <tr key={`${task}${index}`}>
                  { window.location.pathname === "/" &&
                    <td width="70%" className="ps-0">
                      <Link to={`/my-tasks/${task?.task?.id}`} className="p-0 text-black">{task?.task?.title}</Link>
                    </td>
                  }
                  { window.location.pathname !== "/" &&
                    <td width="40%" onClick={() => onClickTableItem(task)}>
                      {task?.task?.title}
                    </td>
                  }
                  <td width="30%">
                    {task?.task?.implementation_timeline_end
                      ? moment(
                          getYMDDate(task?.task?.implementation_timeline_end) ??
                            ""
                        ).format("ll")
                      : "-"}
                  </td>

                  { window.location.pathname !== "/" &&
                    <td width="30%">
                      <Link
                        className={`col-12 col-md-6 col-lg-auto mt-4 ${_getLinkClassName()}`}
                        key={index}
                        to={`/board/${task?.board_id}`}
                      >
                        {task?.board_name}
                      </Link>
                    </td>
                  }
                </tr>
              );
            })}
      </tbody>
    </Table>
  );
};

export default TaskTable;
